import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  ViewChild,
} from "@angular/core";
import {
  HintsEditorComponent,
  InstructionsEditorComponent,
  SenseiHelpEditorComponent,
} from "src/app/editors/components";
import { SolveSubActivityStep } from "src/app/models";

@Component({
  selector: "app-solve-activity-step",
  templateUrl: "./solve-activity-step.component.html",
  styleUrls: ["./solve-activity-step.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolveActivityStepComponent {
  @HostBinding("class") class = "app-solve-activity-step";

  @Input() step: SolveSubActivityStep;

  @ViewChild(InstructionsEditorComponent)
  instructions: InstructionsEditorComponent;

  @ViewChild(HintsEditorComponent)
  hints: HintsEditorComponent;

  @ViewChild(SenseiHelpEditorComponent)
  senseiHelp: SenseiHelpEditorComponent;

  get value(): SolveSubActivityStep {
    return {
      ...this.step,
      instructions: this.instructions.value,
      hints: this.hints.value,
      senseiHelp: this.senseiHelp.value,
    };
  }

  get valid(): boolean {
    return !!(
      this.instructions?.valid &&
      this.hints?.valid &&
      this.senseiHelp?.valid
    );
  }

  get dirty(): boolean {
    return !!(
      this.instructions?.dirty ||
      this.hints?.dirty ||
      this.senseiHelp?.dirty
    );
  }
}
